export const organizationsPathname = '/organizations';
export const guidePathname = '/organization-guide';
